import type { TypePromotionHighlights } from "@/types/contentful/generated";

export type PromotionHighlightsFields = TypePromotionHighlights<undefined, string>["fields"];

// Deliberately narrow to properties schema.org actually defines on Offer.
// `discount`, `discountCode` and `discountCurrency` belong to Order, not Offer,
// and `priceCurrency` says nothing without a `price`. The promo code still
// reaches consumers through the `?promo=` parameter on redemptionUrl, and stays
// in the visible copy.
//
// `active` is not read here — PromotionHighlights gates rendering (and JSON-LD
// emission) on it before calling this builder.
export function buildPromotionOfferJsonLd({
  name,
  description,
  redemptionUrl,
  availabilityStarts,
  availabilityEnds,
}: PromotionHighlightsFields) {
  return {
    "@context": "https://schema.org",
    "@type": "Offer",
    name,
    description,
    url: redemptionUrl,
    availability: "https://schema.org/InStock",
    ...(availabilityStarts && { availabilityStarts }),
    ...(availabilityEnds && { availabilityEnds }),
    offeredBy: {
      "@type": "Organization",
      name: "StickerGiant",
      url: "https://www.stickergiant.com",
    },
  };
}
